if (!customElements.get('dg-gift-finder')) {
  customElements.define('dg-gift-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.events = new AbortController();
      this.form = this.querySelector('form');
      this.choices = [...this.querySelectorAll('[data-gift-choice]')];
      this.api = window.DuduGiftCatalog;
      this.strings = Object.fromEntries(Object.entries(JSON.parse(this.querySelector('[data-gift-strings]').textContent)).map(([key,value])=>[key,this.api.decode(value)]));
      this.status = this.querySelector('[data-gift-status]');
      this.submit = this.querySelector('[type=submit]');
      this.recovery = this.querySelector('[data-gift-recovery]');
      this.cache = new Map();
      this.checkVersion = 0;
      const settings = { signal: this.events.signal };
      this.choices.forEach(choice => {
        const summary = choice.querySelector('summary');
        const search = choice.querySelector('[data-gift-search]');
        summary.addEventListener('click', () => {
          if (!choice.open) { search.value = ''; this.filterOptions(choice); }
        }, settings);
        choice.addEventListener('toggle', () => {
          if (!choice.open) return;
          this.choices.forEach(other => { if (other !== choice) other.open = false; });
          this.filterOptions(choice);
          this.updateOptions(choice);
          search.focus();
        }, settings);
        search.addEventListener('input', () => this.filterOptions(choice), settings);
        choice.addEventListener('click', event => {
          const option = event.target.closest('[data-gift-option]');
          if (!option || option.disabled) return;
          this.select(choice, option.dataset.giftOption);
          choice.open = false;
          summary.focus();
        }, settings);
        choice.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            choice.open = false;
            summary.focus();
          }
          if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          if (event.target === summary) {
            if (event.key === 'ArrowDown') { event.preventDefault(); search.value = ''; this.filterOptions(choice); choice.open = true; }
            return;
          }
          const options = [...choice.querySelectorAll('[data-gift-option]')].filter(option => !option.disabled && !option.closest('li').hidden);
          if (!options.length) return;
          event.preventDefault();
          const current = options.indexOf(event.target);
          let next = event.key === 'ArrowUp' ? current - 1 : current + 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = options.length - 1;
          options[(next + options.length) % options.length].focus();
        }, settings);
      });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.choices.forEach(choice => { choice.open = false; });
      }, settings);
      this.querySelectorAll('[data-gift-reset]').forEach(button => {
        button.addEventListener('click', () => {
          this.select(this.choices.find(choice => choice.dataset.giftChoice === button.dataset.giftReset), '');
        }, settings);
      });
      this.form.addEventListener('submit', async event => {
        event.preventDefault();
        this.choices.forEach(choice => { choice.open = false; });
        const url = this.resultUrl();
        if (![...url.searchParams.keys()].length) { window.location.assign(url.href); return; }
        this.submit.disabled = true;
        try {
          const data = await this.fetchData(url);
          if (!data.ready) throw new Error('Unavailable');
          if (data.count === 0) { this.showZero(); return; }
          window.location.assign(url.href);
        } catch {
          this.status.textContent = this.strings.unavailable;
        } finally {
          this.submit.disabled = false;
        }
      }, settings);
    }
    disconnectedCallback() {
      this.events?.abort();
      clearTimeout(this.timer);
      this.connected = false;
    }
    resultUrl(exclude) {
      const url = new URL(this.dataset.giftUrl, window.location.origin);
      this.choices.forEach(choice => {
        const input = choice.querySelector('[data-gift-value]');
        if (input.value && choice !== exclude) url.searchParams.set(input.name, input.value);
      });
      return url;
    }
    async fetchData(url) {
      const products = await this.api.load(this.dataset.giftUrl);
      const criteria = this.api.read(url);
      const count = products.filter(product=>this.api.matches(product,criteria)).length;
      const keys = {dg_recipient:'recipients',dg_interest:'interests',dg_occasion:'occasions'};
      const filters = Object.entries(keys).map(([parameter,key])=>({parameter,values:[...new Set(products.flatMap(product=>product[key]))].map(value=>({value,label:value,count:products.filter(product=>this.api.matches(product,{...criteria,[key]:[value]})).length}))}));
      return {ready:true,count,filters};
    }
    filterOptions(choice) {
      const term = choice.querySelector('[data-gift-search]').value.trim().toLocaleLowerCase();
      let count = 0;
      choice.querySelectorAll('[data-gift-option]').forEach(option => {
        const match = option.dataset.giftOption.toLocaleLowerCase().includes(term) || (!option.dataset.giftOption && option.textContent.toLocaleLowerCase().includes(term));
        option.closest('li').hidden = !match;
        if (match) count++;
      });
      choice.querySelector('[data-gift-search-empty]').hidden = count > 0;
    }
    select(choice, value) {
      const input = choice.querySelector('[data-gift-value]');
      const option = [...choice.querySelectorAll('[data-gift-option]')].find(item => item.dataset.giftOption === value);
      if (!option) return;
      input.value = value;
      input.disabled = !value;
      choice.querySelector('[data-gift-selected]').textContent = option.childNodes[0].textContent;
      choice.querySelectorAll('[data-gift-option]').forEach(item => item.setAttribute('aria-selected', String(item === option)));
      this.recovery.hidden = true;
      clearTimeout(this.timer);
      this.checkVersion++;
      this.timer = setTimeout(() => this.checkCount(), 180);
    }
    async updateOptions(choice) {
      const url = this.resultUrl(choice);
      const snapshot = url.href;
      try {
        const data = await this.fetchData(url);
        if (!data.ready || this.resultUrl(choice).href !== snapshot) return;
        const filter = data.filters.find(item => item.parameter === choice.dataset.parameter);
        if (!filter) return;
        for (const item of filter.values) {
          if ([...choice.querySelectorAll('[data-gift-option]')].some(option=>option.dataset.giftOption===item.value)) continue;
          const li=document.createElement('li'),button=document.createElement('button'),count=document.createElement('span');
          button.type='button';button.setAttribute('role','option');button.setAttribute('aria-selected','false');button.dataset.giftOption=item.value;button.append(document.createTextNode(item.label));count.className='dg-gift-option-count';count.dataset.giftOptionCount='';button.append(count);li.append(button);choice.querySelector('ul').append(li);
        }
        const counts = new Map(filter.values.map(item => [item.value, item.count]));
        const input = choice.querySelector('[data-gift-value]');
        choice.querySelectorAll('[data-gift-option]').forEach(option => {
          const value = option.dataset.giftOption;
          if (!value) return;
          const count = counts.get(value) || 0;
          option.disabled = count === 0 && input.value !== value;
          option.querySelector('[data-gift-option-count]').textContent = String(count);
        });
        this.filterOptions(choice);
      } catch {}
    }
    async checkCount() {
      const version = this.checkVersion;
      const url = this.resultUrl();
      if (![...url.searchParams.keys()].length) {
        this.status.textContent = this.strings.initial;
        this.submit.disabled = false;
        this.recovery.hidden = true;
        return;
      }
      this.status.textContent = this.strings.checking;
      try {
        const data = await this.fetchData(url);
        if (version !== this.checkVersion) return;
        if (!data.ready) throw new Error('Unavailable');
        if (!data.count) { this.showZero(); return; }
        this.status.textContent = data.count === 1 ? this.strings.one : this.strings.count.replace('[count]', String(data.count));
        this.recovery.hidden = true;
        this.submit.disabled = false;
      } catch {
        if (version === this.checkVersion) this.status.textContent = this.strings.unavailable;
      }
    }
    showZero() {
      this.status.textContent = this.strings.zero;
      this.recovery.hidden = false;
      this.submit.disabled = false;
      this.recovery.querySelectorAll('[data-gift-reset]').forEach(button => {
        const choice = this.choices.find(item => item.dataset.giftChoice === button.dataset.giftReset);
        button.hidden = !choice.querySelector('[data-gift-value]').value;
      });
    }
  });
}
